import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const BaseIcon = () => {
    return (
        <SvgIcon viewBox="0 0 36 36">
            <line x1="8" y1="18" x2="28" y2="18" stroke="white" strokeWidth="2"/>
        </SvgIcon>
    );
}